import { render } from "./quiz.vue?vue&type=template&id=2190eb1e&scoped=true"
import script from "./quiz.vue?vue&type=script&lang=js"
export * from "./quiz.vue?vue&type=script&lang=js"

import "./quiz.vue?vue&type=style&index=0&id=2190eb1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2190eb1e"]])

export default __exports__